// src/components/HomePage.jsx
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import "./businessCRMAnalytics.css";

export default function BusinessSampleCRM({ onViewSelect }) {
  
  const pieData = [
    { name: "Category A", value: 400 },
    { name: "Category B", value: 300 },
    { name: "Category C", value: 300 },
    { name: "Category D", value: 200 }
  ];

  const COLORS = ["#6ce5e8", "#e2cbf6", "#ffeb99", "#2f5f98"];

  return (
    <div className="home-container">
      <div className="home-card">

        {/* Top nav bar */}
        <div className="top-nav">
          <div className="nav-left">
            <button className="nav-tab"  onClick={() => onViewSelect('admin')}
            >
              General
            </button>
            <button className="nav-tab" onClick={() => onViewSelect('adminCalendar')}
            >
              Event Calendar
            </button>
            <button className="nav-tab" onClick={() => onViewSelect('adminEventManagement')}
            >
              Event Management
            </button>
            <button className="nav-tab active">KPI Dashboard</button>
            <button className="nav-tab" onClick={() => onViewSelect('user-management')}>
              User Management
            </button>
            <button className="nav-tab" onClick={() => onViewSelect('business-management')}>
              Business Management
            </button>
          </div>
        </div>
        
        <div className="dash-title-container">
          <button className="return-button"onClick={() => onViewSelect('adminKPIDash')} >Go Back</button>
        </div>

        <div>
          <h1 className="home-title"> KPI NAME </h1>
        </div>

        {/* Pie Chart */}
        <div style={{ width: "100%", height: 400, marginTop: "2rem" }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                outerRadius={120}
                fill="#ffffffff"
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>


      </div>
    </div>
  );
}